import { useState } from "react";
import styled from "styled-components";
import { colors } from "utils";

export const ButtonBubble = ({ text, children, display }) => {
  const [open, setOpen] = useState(true);

  return (
    <Container>
      <div>
        {children}
      </div>

      {open && display && <Bubble>
        <p>{text}</p>

        <button onClick={() => setOpen(false)} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M2.05155 15.648C1.58223 16.1173 0.82131 16.1173 0.35199 15.648C-0.11733 15.1787 -0.11733 14.4178 0.35199 13.9485L5.29897 9.00147C5.85207 8.44837 5.85207 7.55162 5.29897 6.99853L0.35199 2.05155C-0.11733 1.58223 -0.11733 0.82131 0.35199 0.35199C0.82131 -0.11733 1.58223 -0.11733 2.05155 0.35199L6.99852 5.29897C7.55162 5.85207 8.44837 5.85207 9.00147 5.29897L13.9485 0.35199C14.4178 -0.11733 15.1787 -0.11733 15.648 0.35199C16.1173 0.82131 16.1173 1.58223 15.648 2.05155L10.701 6.99852C10.1479 7.55162 10.1479 8.44837 10.701 9.00147L15.648 13.9485C16.1173 14.4178 16.1173 15.1787 15.648 15.648C15.1787 16.1173 14.4178 16.1173 13.9485 15.648L9.00147 10.701C8.44837 10.1479 7.55162 10.1479 6.99853 10.701L2.05155 15.648Z" fill="white" />
          </svg>
        </button>
      </Bubble>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

/* The bubble hangs BELOW the button (absolute, so the answer row doesn't
   resize when it appears), centered, with the caret pointing up at it. */
export const Bubble = styled.div`
  display: flex;
  color: white;
  background-color: ${colors.pink700};
  padding: 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  position: absolute;
  top: calc(100% + 14px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 260px;
  z-index: 10;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid ${colors.pink700};
  }

  & button {
    border: none;
    background: none;
    padding: 0 0 2px 12px;
  }
`
